import * as React from 'react';

export interface ITab {
    className?: string;
    icon?: React.ReactNode;
    id: string;
    tabHeaderId?: string;
    tabPanelId?: string;
    title: string;
    subtitle?: string;
}

export class Tab extends React.Component<ITab> {
    public render() {
        return this.props.children;
    }
}
